import { DataUrl } from '@barthauer/abc/core';
import { MtObject } from './MtObject';

export class MtTicketCreationDocument {
  Designation: string;
  DataUrl: DataUrl;
  File: File;
}

export class MtTicketTaskCreation {
  Bezeichnung: string;
  LfdNr: number;
  Status: string;
  StartDatum: Date;
  StartZeit: Date;
  EndDatum: Date;
  EndZeit: Date;
  IdRefMtResource: string;
  CreateActiveReminder: boolean;
}

export class MtTicketCreation {
  Id: string;
  Object?: MtObject;
  Dringlichkeit?: string;
  Status?: string;
  Bezeichnung: string;
  Kategorie?: string;
  Beschreibung?: string;
  Herkunft?: string;
  StartDatum: Date;
  EndDatum: Date;
  IdRefPersonBearbeiter?: string;
  Documents: MtTicketCreationDocument[];
  Tasks: MtTicketTaskCreation[];

  constructor() {
    this.Documents = new Array<MtTicketCreationDocument>();
    this.Tasks = new Array<MtTicketTaskCreation>();
  }
}
